import axios from "axios";
import Config from "src/config";

const v1_actionWboTemplatesCategoryLogsMarcarVistos = (clienteId) => {
    const url = `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/logs/categoria/marcar-vistos`;

    return axios({
        method: "patch",
        url: url
    });
};

export default v1_actionWboTemplatesCategoryLogsMarcarVistos;
